import { validate, isHexColor } from 'wix-rich-content-common';
import { isObject } from 'lodash';
import { DEFAULT_PALETTE } from './constants.js';
import './text-decorations-utils.js';
import './types.js';

var definitions = {
};
var $schema = "http://json-schema.org/draft-07/schema#";
var $id = "color-scheme";
var type = "object";
var title = "color-scheme schema";
var required = [
	"color",
	"index"
];
var properties = {
	color: {
		$id: "#/properties/color",
		type: "string",
		title: "hex color",
		"default": "",
		examples: [
			"#fff",
			"#bada55"
		],
		pattern: "^#[0-9a-f]{3}(?:[0-9a-f]{3})?$"
	},
	index: {
		$id: "#/properties/index",
		type: "integer",
		title: "color index",
		"default": 0,
		examples: [
			0
		]
	}
};
var schema = {
	definitions: definitions,
	$schema: $schema,
	$id: $id,
	type: type,
	title: title,
	required: required,
	properties: properties
};

const validateColorScheme = (colorScheme) => isObject(colorScheme) && Object.values(colorScheme).every((value) => validate(value, schema));
const extractColor = (colorScheme, style) => {
  if (colorScheme && colorScheme[style]) {
    return colorScheme[style].color;
  } else if (isHexColor(style)) {
    return style;
  }
};
const extractPalette = (colorScheme) => {
  if (!colorScheme) {
    return DEFAULT_PALETTE;
  }
  return Object.values(colorScheme).sort((entry1, entry2) => entry1.index > entry2.index ? 1 : -1).map((entry) => entry.color);
};
const extractSchemeAttributes = (colorScheme) => {
  if (!colorScheme) {
    return null;
  }
  return Object.keys(colorScheme).reduce((sorted, key) => {
    if (!sorted.length || colorScheme[key].index > colorScheme[sorted[0]].index) {
      sorted.push(key);
    } else {
      sorted.unshift(key);
    }
    return sorted;
  }, []);
};

export { extractColor, extractPalette, extractSchemeAttributes, validateColorScheme };
//# sourceMappingURL=color-scheme-utils.js.map
